import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import Localization from "../../localization";
import Gallery from "../../components/gallery";
import IconSpacesPT from "../../components/icons/spacesPT";
import IconSpacesEN from "../../components/icons/spacesEN";
import IconArrow from "../../components/icons/arrow";
import { fixExternalLinks } from "../../utils/helper";
import { changeFloor, changeMobileFloor } from "../../redux/actions/options";
import { loadPage } from "../../redux/actions/pages";
import { loadSpaces } from "../../redux/actions/spaces";

class Spaces extends Component {
    componentDidMount() {
        this.props.loadPage("spaces_home");
        this.props.loadSpaces();
    }

    render() {
        const { spacesData, locale, changeFloor, changeMobileFloor } =
            this.props;

        if (!spacesData) return <div className="h-screen" />;

        return (
            <div className="pt-60 xl:pt-100 pb-50 xl:pb-100 px-16 xl:px-50 bg-blue">
                <h1 className="font-judge font-bold pb-40 xl:pb-80 text-50 xl:text-100 text-orange text-center uppercase">
                    {Localization[locale].spaces.info_title}
                </h1>
                <Gallery
                    data={spacesData.gallery}
                    showCoverflow={true}
                    width={null}
                />
                {spacesData.content.map((section) => (
                    <div key={section.key}>
                        <div className="flex mt-40 xl:mt-120 mb-30 xl:mb-40">
                            <div className="xl:w-4/12" />
                            <div className="xl:w-8/12">
                                <h1 className="font-judge font-bold text-17 xl:text-30 text-orange mb-30 xl:mb-40">
                                    {section.attributes.title}
                                </h1>
                                <p className="font-bold text-30 xl:text-60 text-orange">
                                    {section.attributes.subtitle}
                                </p>
                            </div>
                        </div>
                        <div className="flex xl:mb-100">
                            <div className="xl:w-6/12" />
                            <div className="xl:w-6/12">
                                <div
                                    className="article-body font-bold leading-tight text-17 xl:text-23 text-orange"
                                    dangerouslySetInnerHTML={{
                                        __html: fixExternalLinks(
                                            section.attributes.body
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                <div className="xl:hidden my-40 flex-col w-full">
                    <p className="text-20 font-bold mb-12 text-orange">
                        Piso 0
                    </p>
                    <div className="flex border-t border-orange items-center">
                        <Link
                            onClick={() => {
                                changeMobileFloor(true, "estudio-1-piso-0");
                            }}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1 text-orange"
                            }
                            title={
                                Localization[locale].spaces_booking
                                    .step_1_studio_1
                            }
                        >
                            {
                                Localization[locale].spaces_booking
                                    .step_1_studio_1
                            }
                        </Link>
                        <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                    </div>
                    <div className="flex border-t border-orange items-center">
                        <Link
                            onClick={() => {
                                changeMobileFloor(true, "estudio-2-piso-0");
                            }}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1 text-orange"
                            }
                            title={
                                Localization[locale].spaces_booking
                                    .step_1_studio_2
                            }
                        >
                            {
                                Localization[locale].spaces_booking
                                    .step_1_studio_2
                            }
                        </Link>
                        <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                    </div>
                    <div className="flex border-t border-b border-orange items-center">
                        <Link
                            onClick={() => {
                                changeMobileFloor(true, "oficina");
                            }}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1 text-orange"
                            }
                            title={Localization[locale].spaces_booking.workshop}
                        >
                            {Localization[locale].spaces_booking.workshop}
                        </Link>
                        <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                    </div>
                    <p className="text-20 font-bold mb-12 mt-40 text-orange">
                        Piso 1
                    </p>
                    <div className="flex border-t border-orange items-center">
                        <Link
                            onClick={() => {
                                changeMobileFloor(true, "estudio-3-piso-1");
                            }}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1 text-orange"
                            }
                            title={
                                Localization[locale].spaces_booking
                                    .step_1_studio_3
                            }
                        >
                            {
                                Localization[locale].spaces_booking
                                    .step_1_studio_3
                            }
                        </Link>
                        <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                    </div>
                    <div className="flex border-t border-b border-orange items-center">
                        <Link
                            onClick={() => {
                                changeMobileFloor(true, "estudio-4-piso-1");
                            }}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1 text-orange"
                            }
                            title={
                                Localization[locale].spaces_booking
                                    .step_1_studio_4
                            }
                        >
                            {
                                Localization[locale].spaces_booking
                                    .step_1_studio_4
                            }
                        </Link>
                        <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                    </div>
                </div>
                <div className="hidden xl:flex flex-col items-center justify-center">
                    {locale === "pt" ? (
                        <IconSpacesPT
                            onFloor1Click={() => {
                                changeFloor(true, "estudio-1-piso-0");
                            }}
                            onFloor2Click={() => {
                                changeFloor(true, "estudio-2-piso-0");
                            }}
                            onFloor3Click={() => {
                                changeFloor(true, "estudio-3-piso-1");
                            }}
                            onFloor4Click={() => {
                                changeFloor(true, "estudio-4-piso-1");
                            }}
                            onFloorOClick={() => {
                                changeFloor(true, "oficina");
                            }}
                            onFloorCClick={() => {
                                changeFloor(true, "cozinha");
                            }}
                            onFloorSClick={() => {
                                changeFloor(true, "sala");
                            }}
                            onFloorEEClick={() => {
                                changeFloor(true, "espaco-exterior");
                            }}
                        />
                    ) : (
                        <IconSpacesEN
                            onFloor1Click={() => {
                                changeFloor(true, "estudio-1-piso-0");
                            }}
                            onFloor2Click={() => {
                                changeFloor(true, "estudio-2-piso-0");
                            }}
                            onFloor3Click={() => {
                                changeFloor(true, "estudio-3-piso-1");
                            }}
                            onFloor4Click={() => {
                                changeFloor(true, "estudio-4-piso-1");
                            }}
                            onFloorOClick={() => {
                                changeFloor(true, "oficina");
                            }}
                            onFloorCClick={() => {
                                changeFloor(true, "cozinha");
                            }}
                            onFloorSClick={() => {
                                changeFloor(true, "sala");
                            }}
                            onFloorEEClick={() => {
                                changeFloor(true, "espaco-exterior");
                            }}
                        />
                    )}
                </div>
                <div className="flex mt-40 xl:mt-137">
                    <div className="xl:w-4/12" />
                    <div className="xl:w-8/12">
                        <div className="xl:w-7/12">
                            <div
                                className="text-17 text-orange whitespace-pre-wrap"
                                dangerouslySetInnerHTML={{
                                    __html: Localization[locale].spaces
                                        .conditions_text,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    spacesData: state.pages.spaces_home,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeMobileFloor,
            changeFloor,
            loadPage,
            loadSpaces,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Spaces);
